import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InquiryTypeModel } from '../../models/InquiryTypeModel'


export interface InquiryTypeState {
    InquiryType: InquiryTypeModel
    InquiryTypeList: InquiryTypeModel[]
}

const initialState: InquiryTypeState = {
    InquiryType: {} as InquiryTypeModel,
    InquiryTypeList: [],
}

export const InquiryTypeSlice = createSlice({
    name: 'inquiryType',
    initialState,
    reducers: {
        setInquiryType: (state, action: PayloadAction<InquiryTypeModel[]>) => {
            state.InquiryTypeList = action.payload
        },
        saveInquiryType: (state, action: PayloadAction<InquiryTypeModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: InquiryTypeModel = { Id: 0, InquiryTypeName: room.InquiryTypeName }
                let currentRoom =
                    state.InquiryTypeList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.InquiryTypeName = room.InquiryTypeName
            } else {
                room.Id = (Math.max(...state.InquiryTypeList.map((c) => c.Id)) || 0) + 1
                state.InquiryTypeList.push(room)
            }
        },
        getInquiryTypeById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let InquiryType: InquiryTypeModel = {} as InquiryTypeModel
            if (id > 0) {
                let currentInquiryType: InquiryTypeModel[] = state.InquiryTypeList
                InquiryType = currentInquiryType.find((c) => c.Id === id) || ({} as InquiryTypeModel)
            }

            state.InquiryType = InquiryType
        },
        deleteInquiryType: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentInquiryType: InquiryTypeModel[] = state.InquiryTypeList
                state.InquiryTypeList = currentInquiryType.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setInquiryType, saveInquiryType, getInquiryTypeById, deleteInquiryType } =
InquiryTypeSlice.actions

export default InquiryTypeSlice.reducer
